import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PrintService } from '../../print-layout/print.service';
import { StateLicensedInReportService } from './statelicensedinreport.service';
import { StateLicensedInReportView } from './statelicensedinreport.model';

@Component({
    selector: 'app-form-statelicensedinreport',
    templateUrl: './statelicensedinreport.component.html',
    styleUrls: ['./statelicensedinreport.component.scss']
})
export class StateLicensedInReportComponent {
    rowIds: string[];
    reportList: StateLicensedInReportView[] = [];
    reporttype: string;
    print: string;

    constructor(
        private route: ActivatedRoute,
        private reportService: StateLicensedInReportService,
        private printService: PrintService,
        private http: HttpClient
    ) {
        this.rowIds = route.snapshot.params['Id'].split(',');
        this.reporttype = this.rowIds[1];
        this.print = this.rowIds[0];
    }

    ngOnInit() {
        let headerEl = document.querySelector('.header.header-space') as HTMLElement;
        if (headerEl) {
            headerEl.style.display = 'none';
        }

        this.reportService.getStateLicensedInReportList()
            .toPromise()
            .then(res => {
                this.reportList = res;
                if (this.print == 'PDF') {
                    this.printService.onDataReady(true, this.reporttype, 'PDF');
                }
                if (this.print == 'EXCEL') {
                    this.printService.onDataReady(true, this.reporttype, 'EXCEL', this.reporttype + '.xlsx', 0, 'statelicensedintable');
                }
            })
            .catch(err => { console.log(err) });
    }
}
